import type { Node, NodeProps } from '@xyflow/react';
import { Handle, Position } from '@xyflow/react';
import { Database, Globe, Server, Zap } from 'lucide-react';
import type { IZoneStatus, TServiceData } from '@/data';
import type { ZONE } from '@/enums';
import { SERVICE_TYPE } from '@/enums';
import { BottomDetail, ServiceHeader } from './components';
const getServiceIcon = (type: SERVICE_TYPE) => {
  switch (type) {
    case SERVICE_TYPE.WEB_APP:
      return Globe;
    case SERVICE_TYPE.SERVICE:
      return Server;
    case SERVICE_TYPE.DATABASE:
      return Database;
    case SERVICE_TYPE.CACHE:
      return Zap;
    default:
      return Server;
  }
};
export const DefaultNode: React.FC<NodeProps<Node<TServiceData>>> = props => {
  const zones = Object.entries(props.data.zones as Record<ZONE, IZoneStatus>);
  return <div className='relative min-w-60 max-w-60'>
      <div className='rounded-lg border border-foreground/10 bg-foreground/5 pt-3 pr-3 pb-2 pl-1 shadow-md backdrop-blur'>
        <div className='border-2 border-primary/0 border-l-primary pl-2'>
          <ServiceHeader Icon={getServiceIcon(props.data.type)} status={props.data.status} zones={zones} />
          <h3 className='mb-1 font-semibold text-gray-900 text-sm dark:text-white'>
            {props.data.name}
          </h3>
          <p className='text-gray-600 text-xs dark:text-gray-400'>
            {props.data.description}
          </p>
        </div>
      </div>
      <BottomDetail responseTime={props.data.responseTime} uptime={props.data.uptime} />
      <div className='-left-2 absolute top-4 size-2 rounded-l-full bg-foreground'>
        <Handle position={Position.Left} style={{
        border: 'none',
        backgroundColor: 'transparent'
      }} type='target' />
      </div>
      <div className='-right-2 absolute top-4 size-2 rounded-r-full bg-primary'>
        <Handle position={Position.Right} style={{
        border: 'none',
        backgroundColor: 'transparent'
      }} type='source' />
      </div>
    </div>;
};